import { useQuery, useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '@shared/api/client';
import { TELEGRAM } from '@shared/api/endpoints';
import { isBitrix24Context } from '@shared/hooks/useBitrix24';
import type { TelegramLinkTokenResponse, TelegramStatusResponse } from '@tailorcast/shared-types';

export function useTelegramLink() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: () => api.post<TelegramLinkTokenResponse>(TELEGRAM.GENERATE_LINK),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['telegram', 'status'] });
    },
  });
}

export function useTelegramStatus() {
  return useQuery({
    queryKey: ['telegram', 'status'],
    queryFn: () => api.get<TelegramStatusResponse>(TELEGRAM.STATUS),
    enabled: isBitrix24Context(),
    refetchInterval: (query) => (query.state.data?.linked ? false : 3000),
    staleTime: 30_000,
  });
}
